// Mock content for the Miranda & Mirza wedding invitation.
// All data lives here so backend integration (e.g. RSVP) is easy to wire later.

export const weddingData = {
  names: {
    one: "მირანდა",
    two: "მირზა",
    initials: "მ&მ",
  },
  date: {
    // Wedding target used by the countdown timer
    iso: "2026-10-18T18:00:00",
    display: "18 ოქტომბერი, 2026",
    short: "18.10.2026",
    dotted: "18 · 10 · 2026",
    time: "18:00",
    dayOfWeek: "კვირა",
  },
  // Main invitation paragraphs (editorial / italic). Hearts rendered as icons.
  invitation: {
    paragraphs: [
      { text: "დიდი სიყვარულით გეპატიჟებით\nჩვენი ბედნიერების გასაზიარებლად", heart: true },
    ],
    dateLine: "18 ოქტომბერი, 2026 | 18:00",
    venueLine: "სარიტუალო დარბაზი „დიას ჰოლი“",
    addressLine: "აეროპორტის გზატკეცილი 243ა",
    closing: "გელოდებით ჩვენს ყველაზე\nლამაზ დღეს.",
  },
  photos: {
    main: "https://customer-assets-jt897jd0.emergentagent.net/job_diana-love-replica/artifacts/5845kwm6_ddd20c7f-16ad-4ae3-b72e-ad974b2ee26e.jpeg",
    left: "https://customer-assets-jt897jd0.emergentagent.net/job_diana-love-replica/artifacts/ajjm4dd4_638786ec-10b7-43ed-a393-fcde2f496949.jpeg",
    right: "https://customer-assets-jt897jd0.emergentagent.net/job_diana-love-replica/artifacts/5845kwm6_ddd20c7f-16ad-4ae3-b72e-ad974b2ee26e.jpeg",
  },
  venue: {
    image: "https://customer-assets-jt897jd0.emergentagent.net/job_diana-love-replica/artifacts/4za6w9ot_24eed3d6-70f2-454b-b4b9-97268033bca0.jpeg",
    eyebrow: "ცერემონია და ზეიმი",
    title: "სარიტუალო დარბაზი\n„დიას ჰოლი“",
    date: "18 ოქტომბერი, 2026",
    time: "18:00 სთ",
    address: "აეროპორტის გზატკეცილი 243ა",
    mapsUrl: "https://maps.app.goo.gl/hNDZPiR6yFrF5apU7?g_st=ic",
  },
  program: [
    { time: "13:00", title: "შეხვედრა", note: "სტუმრების მიღება" },
    { time: "15:00", title: "ფოტოსესია", note: "" },
    { time: "17:00", title: "ცერემონია", note: "" },
    { time: "18:00", title: "დარბაზი „დიას ჰოლი“", note: "" },
  ],
  calendar: {
    monthLabel: "ოქტომბერი",
    year: "2026",
    weekdays: ["ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ", "კვი"],
    // October 2026 starts on Thursday (Mon-first grid => 3 leading blanks)
    leadingBlanks: 3,
    daysInMonth: 31,
    weddingDay: 18,
    footer: "კვირა · 18:00",
  },
  music: {
    label: "საქორწინო მელოდია",
    sources: [
      {
        src: "https://upload.wikimedia.org/wikipedia/commons/c/cb/A_Midsummer_Night%27s_Dream_Op._61_Wedding_March_%28Mendelssohn%29_European_Archive.ogg",
        type: "audio/ogg",
      },
      {
        src: "https://upload.wikimedia.org/wikipedia/commons/c/ce/Sousa%27s_%22Wedding_March%22_-_United_States_Marine_Band_%282019%29.mp3",
        type: "audio/mpeg",
      },
    ],
  },
};
